var _defs, _style, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsmda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 77",
    width: 84,
    height: 77,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 85,
    height: 41,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFUAAAApBAMAAAC2O3jTAAAAAXNSR0IB2cksfwAAADBQTFRF////Z7/mp9rw2tratbS0G5/ZkY+PIx8gWldYyMfHSrPh7/bphL1Rz+W81unF7ezsz/J9AAAAAVFJREFUeJxjZCAeMI6qHVWLRS2jAJIg/wNmxz8HXBgY9gMpBhAbRS1rAJLa0w/SBX5OLxBkaKz72MEw/QGDZAFutS/zXi6Y/rIByGznLEj/yS7ZgFvts6IOBvb8z9MZGIA60jXLMyfgUVvQxcBZ//99F5FqGRjYCiBqmf79XIDPvUpA6u+j/gJIAHTgDwcQzTQBbPdZrQIUtVwLkNSWPWCYCaS+FzCgAOrGceZ0dLXcG5CkvyI5njO/A10tzwEktSwGpKiddsHgwizO2F8L2BKEJvZemIVHrVkhyMTnAowd7R8YJ+QzcDbgUVswKW9i5szv7UL3J+ZP/M6OGscYagv7C3ub/vM/mJw/sf7/S4Jq3yn9A6ntK5a7SVAt36N/RvfkH/VnqhNWKwfMENcF/k8oZPiJopbvAZLaTwoQ+oP8R4YPAgz8Hz8IIKslBoyqhQAAiR+TKgU6+P0AAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 3",
    href: "#img1",
    x: -1,
    y: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsmda);
export default __webpack_public_path__ + "static/media/csmda.663f7ea7ccd7411984e0cb6182cea396.svg";
export { ForwardRef as ReactComponent };